import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';
import { ExportPuReportParams } from 'services/api/type/report.type';

import { Dayjs } from 'dayjs';

import { PopupComponents } from './popup-components';

import { toUtcTime } from 'utils';
import { BranchesType } from 'services/api/type/branch.type';
import API from 'services/api/index';

export function ExportPuReport({ currentBranch }: { currentBranch?: BranchesType }) {
  const [pickupFrom, setPickupFrom] = useState<Dayjs | null>(null);
  const [pickupTo, setPickupTo] = useState<Dayjs | null>(null);
  const [viewFrom, setViewFrom] = useState<Dayjs | null>(null);
  const [viewTo, setViewTo] = useState<Dayjs | null>(null);

  const { mutateAsync: mutateExportPUReport } = useMutation({
    mutationFn: (params: ExportPuReportParams) => API.report.exportPuReport(params),
    onSuccess: response => {
      // Handle successful export
      downloadFile(response);
    },
    onError: error => {
      console.error('Export failed:', error);
      // You can add toast notification here
    }
  });

  const downloadFile = (response: any) => {
    try {
      // Check if response is a blob
      if (response instanceof Blob) {
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `PU Report - ${currentBranch?.name} - ${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else if (response.data) {
        // If response has data property (axios response)
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `PU Report - ${currentBranch?.name} - ${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  const handleExport = async () => {
    if (!viewFrom || !viewTo || !pickupFrom || !pickupTo) {
      return;
    }
    try {
      await mutateExportPUReport({
        view_from: toUtcTime(viewFrom.add(1, 'day'), 'YYYY-MM-DD'),
        view_to: toUtcTime(viewTo.add(1, 'day'), 'YYYY-MM-DD'),
        pickup_from: toUtcTime(pickupFrom, 'YYYY-MM-DD HH:mm:ss'),
        pickup_to: toUtcTime(pickupTo, 'YYYY-MM-DD HH:mm:ss'),
        branch_ids: currentBranch?.id
      });
    } catch (error) {
      console.error('Export error:', error);
    }
  };

  return (
    <div className="p-4">
      <PopupComponents
        pickupFrom={pickupFrom}
        pickupTo={pickupTo}
        viewFrom={viewFrom}
        viewTo={viewTo}
        onPickupFromChange={setPickupFrom}
        onPickupToChange={setPickupTo}
        onViewFromChange={setViewFrom}
        onViewToChange={setViewTo}
        onFinish={handleExport}
      />
    </div>
  );
}
